/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Encoding_OptionsInputs */



/**
* | output |
* | --- |
* | "Encoding Options" |
*
* @param {Dialogue_List_Export_Encoding_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_encoding_options = /** @type {((inputs?: Dialogue_List_Export_Encoding_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Encoding_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options d'encodage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kodierungsoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di codifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры кодирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de codificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编码选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エンコードオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एन्कोडिंग विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de codificação")
	return /** @type {LocalizedString} */ ("Encoding Options")
});